import { useTranslation } from '@crehana/i18n';
import locales, { ATS_PUBLIC_CANDIDATE_FORM, type TKeys } from '.';

export const useAddResourceBundle = () => {
  const { addResourceBundle } = useTranslation<TKeys>(
    ATS_PUBLIC_CANDIDATE_FORM,
  );
  addResourceBundle(locales);
};
